import DevicePoolBar from './DevicePoolBar'

function SharedDevicePoolCard({
	isDarkMode,
	teamData,
	togglingSharedPool,
	onToggleSharedPool,
}) {
	return (
		<div
			className={`rounded-lg border p-4 ${
				isDarkMode ? 'border-gray-700 bg-gray-800/50' : 'border-gray-200 bg-gray-50'
			}`}
		>
			<div className="flex items-center justify-between">
				<div>
					<h3
						className={`text-sm font-semibold ${
							isDarkMode ? 'text-white' : 'text-gray-900'
						}`}
					>
						Shared Device Pool
					</h3>
					<p
						className={`text-xs mt-1 ${
							isDarkMode ? 'text-gray-400' : 'text-gray-500'
						}`}
					>
						Share device limits across all team members instead of per-user limits
					</p>
				</div>
			{teamData.isOwner && (
				<button
					onClick={onToggleSharedPool}
					disabled={togglingSharedPool}
					className={`relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors ${
						teamData.team.sharedDevicePool
							? 'bg-blue-600'
							: isDarkMode
							? 'bg-gray-600'
							: 'bg-gray-300'
					} ${togglingSharedPool ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
				>
					<span
						className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
							teamData.team.sharedDevicePool ? 'translate-x-6' : 'translate-x-1'
						}`}
					/>
				</button>
			)}
			</div>
			{teamData.team.sharedDevicePool && teamData.devicePool && (
				<div className={`mt-4 pt-4 border-t space-y-3 ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
					<DevicePoolBar
						label="Extension Devices"
						used={teamData.devicePool.usage.extensionDevices}
						total={teamData.devicePool.limits.extensionDevices}
						isDarkMode={isDarkMode}
					/>
					<DevicePoolBar
						label="Website Devices"
						used={teamData.devicePool.usage.websiteDevices}
						total={teamData.devicePool.limits.websiteDevices}
						isDarkMode={isDarkMode}
					/>
					<DevicePoolBar
						label="Mobile Devices"
						used={teamData.devicePool.usage.mobileDevices ?? 0}
						total={teamData.devicePool.limits.mobileDevices ?? 0}
						isDarkMode={isDarkMode}
					/>
				</div>
			)}
		</div>
	)
}

export default SharedDevicePoolCard
